import React from "react";
import styles from "./TranscriptTableControls.module.css";
import {CustomDateRangePicker} from "../../../../elements/datePicker/CustomDateRangePicker";
import {BroomButton} from "../../../../elements/broomButton/BroomButton";
import {SearchField} from "../../../../elements/searchField/SearchField";
import {
    MultiSelectTableFilterDropdown
} from "../../../../elements/multiSelectTableFilter/MultiSelectTableFilterDropdown";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {
    resetTranscriptTableRequest,
    transcriptTableRequestSelector,
    updateTranscriptTableRequest
} from "../../transcriptListSlice";
import moment from "moment";
import {ConversationStatus, EventType} from "../../../../../api/generated";
import {chatOutcomeEventListInPriorityOrder} from "../row/cell/chatOutcome/ChatOutcomeCell";
import {SelectOption} from "../../../../elements/select/SelectDropdown";
import {ChatEventCard} from "../../../../elements/chatEventCard/ChatEventCard";
import {FollowUpCard} from "../../../../elements/followUpCard/FollowUpCard";
import {followUpEventsInPriorityOrder} from "../row/cell/followUp/FollowUpCell";
import {getChatOutcomeTitle, getFollowUpTitle} from "../../../../../utils/enumValueTitleUtil";

export const TranscriptTableControls: React.FC = () => {

    const dispatch = useAppDispatch()
    const transcriptTableRequest = useAppSelector(transcriptTableRequestSelector)

    const handleDateRangeChange = (start: moment.Moment, end: moment.Moment) => {
        dispatch(updateTranscriptTableRequest({startDate: start.toISOString(), endDate: end.toISOString()}))
    }

    const getChatOutcomeOptions = (): SelectOption<EventType>[] => {
        return chatOutcomeEventListInPriorityOrder.map(e => {
            return {
                value: e,
                label: getChatOutcomeTitle(e)
            }
        })
    }

    const getFollowUpOptions = (): SelectOption<EventType>[] => {
        return followUpEventsInPriorityOrder.map(e => {
            return {
                value: e,
                label: getFollowUpTitle(e)
            }
        })
    }

    const getConversationStatusOptions = (): SelectOption<ConversationStatus>[] => {
        return [
            {
                value: ConversationStatus.CustomerAssisted,
                label: "Customer Assisted"
            },
            {
                value: ConversationStatus.ContactDetailsProvided,
                label: "Contact Details Provided"
            },
        ]
    }

    const resetFilters = () => {
        dispatch(resetTranscriptTableRequest())
    }

    return <div className={styles.wrapper}>
        <div className={styles.controls}>
            <SearchField
                value={transcriptTableRequest.searchQuery}
                placeholder={'Search Customer, Chat ID, Conversation ID'}
                onChange={newValue => dispatch(updateTranscriptTableRequest({searchQuery: newValue}))}
                width={320}
            />
            <CustomDateRangePicker
                startDate={moment(transcriptTableRequest.startDate)}
                endDate={moment(transcriptTableRequest.endDate)}
                onChange={handleDateRangeChange}
            />
            <MultiSelectTableFilterDropdown<EventType, { eventType: EventType }>
                value={transcriptTableRequest.chatOutcome}
                placeholder={"Filter by Chat Outcome"}
                width={260}
                handleChange={(eventTypes) => dispatch(updateTranscriptTableRequest({chatOutcome: eventTypes}))}
                options={getChatOutcomeOptions()}
                optionComponent={ChatEventCard}
                getOptionProps={(eventType) => ({eventType})}
            />
            <MultiSelectTableFilterDropdown<EventType, { eventType: EventType }>
                value={transcriptTableRequest.followUp}
                placeholder={"Filter by Follow Up"}
                width={220}
                handleChange={(eventTypes) => dispatch(updateTranscriptTableRequest({followUp: eventTypes}))}
                options={getFollowUpOptions()}
                optionComponent={FollowUpCard}
                getOptionProps={(eventType) => ({eventType})}
            />
            <MultiSelectTableFilterDropdown<ConversationStatus, {}>
                value={transcriptTableRequest.conversationStatusList}
                placeholder={"Filter by Conversation Status"}
                width={290}
                handleChange={(statuses) => dispatch(updateTranscriptTableRequest({conversationStatusList: statuses}))}
                options={getConversationStatusOptions()}
            />
        </div>
        <div className={styles.clearButton}>
            <BroomButton disabled={false} handleClick={resetFilters}/>
        </div>
    </div>
}
